<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <div class="md-layout-item md-size-25 plot-type-btn">
      <toggle-buttons :btnList="originNaturalList" @btnValue="getOriginNatural" :editTB="$store.state.plot.localization.regeneration_origin_natural" />
    </div>
    <div class="md-layout-item md-size-18" v-if="$store.state.plot.localization.regeneration_origin_natural === '02'">
      <md-field :md-counter="false" :class="!checkYear($store.state.plot.localization.regeneration_origin_year) ? 'md-invalid' : ''">
        <label for="year">{{ $t("localization.year") }}</label>
        <md-input type="number" name="year" v-model="$store.state.plot.localization.regeneration_origin_year" maxlength="4" />
        <span class="md-error">{{ $t("error.errorRange") }} (1900-2100)</span>
      </md-field>
    </div>
    <div class="md-layout-item md-size-18">
      <md-field :class="!checkRange($store.state.plot.localization.regeneration_mean_h, 0, 10) ? 'md-invalid' : ''">
        <label for="meanH">{{ $t("localization.meanH") }} (m)</label>
        <md-input type="number" step="0.01" name="meanH" v-model="$store.state.plot.localization.regeneration_mean_h" />
        <span class="md-error">{{ $t("error.errorRange") }} (0-10)</span>
      </md-field>
    </div>
    <div class="md-layout-item md-size-18">
      <md-field :class="!checkRange($store.state.plot.localization.regeneration_mean_d, 0, 10) ? 'md-invalid' : ''">
        <label for="meanD">{{ $t("localization.meanD") }} (cm)</label>
        <md-input type="number" name="meanD" v-model="$store.state.plot.localization.regeneration_mean_d" />
        <span class="md-error">{{ $t("error.errorRange") }} (0-10)</span>
      </md-field>
    </div>
    <div class="md-layout-item md-size-18">
      <md-field :class="!checkRange($store.state.plot.localization.regeneration_seedling_nr, 0, 999) ? 'md-invalid' : ''">
        <label for="seedlingNr">{{ $t("localization.seedlingNr") }} (m²)</label>
        <md-input type="number" step="0.01" name="seedlingNr" v-model="$store.state.plot.localization.regeneration_seedling_nr" />
        <span class="md-error">{{ $t("error.errorRange") }} (0-999)</span>
      </md-field>
    </div>

    <div class="md-layout-item md-size-100 std">
      <md-field>
        <std-autocomplete
          v-if="loadStd"
          :data="stdList"
          :label="$t('localization.mainSpecies')"
          :initialValue="$store.state.plot.localization.mainSpecies"
          :initialDisplay="initMainSpecies"
          @result="getMainSpecie"></std-autocomplete>
      </md-field>
    </div>

    <div class="md-layout-item md-size-100 std">
      <md-field>
        <std-autocomplete
          v-if="loadStd"
          :data="stdList"
          :label="$t('localization.mainSpecies') + ' II'"
          :initialValue="$store.state.plot.localization.mainSpecies2"
          :initialDisplay="initMainSpecies2"
          @result="getMainSpecie2"></std-autocomplete>
      </md-field>
    </div>
  </div>
</template>

<script>
import ToggleButtons from '@/components/ToggleButtons'
import StdAutocomplete from '@/components/StdAutocomplete'

import { getDomain } from '@/assets/scripts/domainsManager'
import { checkYear, checkRange, getValue, formatList } from '@/assets/scripts/formatData'

const ORIGIN_NATURAL = 'regeneration_origin'
const STD2 = 'std2'

export default {
  name: 'Regeneration',
  props: ['edit'],
  components: {
    ToggleButtons,
    StdAutocomplete
  },
  data: () => ({
    checkYear: checkYear,
    checkRange: checkRange,
    originNaturalList: {},
    stdList: [],
    initMainSpecies: '',
    initMainSpecies2: '',
    loadStd: false
  }),
  mounted () {
    getDomain(ORIGIN_NATURAL).then(data => {
      this.originNaturalList = data[this.$i18n.locale]
    })
    getDomain(STD2).then(data => {
      this.stdList = formatList(data[this.$i18n.locale])
      if (this.edit ||
        this.$store.state.plot.localization.regeneration_species1_std2.length > 0 ||
        this.$store.state.plot.localization.regeneration_species2_std2.length > 0) {
        this.initMainSpecies = getValue(this.stdList, this.$store.state.plot.localization.regeneration_species1_std2)
        this.initMainSpecies2 = getValue(this.stdList, this.$store.state.plot.localization.regeneration_species2_std2)
      }
      this.loadStd = true
    })
  },
  methods: {
    getOriginNatural: function (originNatural) {
      this.$store.state.plot.localization.regeneration_origin_natural = originNatural
      if (originNatural !== '02') {
        this.$store.state.plot.localization.regeneration_origin_year = null
      }
    },

    getMainSpecie: function (mainSpecies) {
      this.$store.state.plot.localization.regeneration_species1_std2 = mainSpecies
    },

    getMainSpecie2: function (mainSpecies2) {
      this.$store.state.plot.localization.regeneration_species2_std2 = mainSpecies2
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .tog-label {
    margin-top: 23px;
  }

  .plot-type-btn {
    margin-top: -10px;
    /* padding-left: 30px !important; */
  }

  .std {
    margin-top: -10px;
  }
</style>
